import { datadogLogs } from '@datadog/browser-logs';
import axios from 'axios';

import scrubURL from '@app/libs/scrubURL';

const domainDenylist = [
  'hubspot.com',
  'hubapi.com',
  'demdex.net',
  'omtrdc.net',
  'clarity.ms',
  'getsitecontrol.com',
  'getsitectrl.com',
  'userpilot.io',
  'google-analytics.com',
] as const;

/**
 * datadog client logger는 production, stage, netlify preview 환경에서만 datadog으로 로그 정보를 보내도록 합니다.
 */
export async function activateLogger() {
  // TODO HTTP 요청 실패시 버전이 찍히지 않으므로 재시도 가능하게 개선 필요
  // @see https://github.com/modusign/modusign-client/pull/7944#discussion_r1108012767
  if (process.env.REACT_APP_MODUSIGN_ENV !== 'development') {
    const version =
      (await axios('/version.json')
        .then((res) => res.data.version)
        .catch(() => null)) ?? null;

    datadogLogs.init({
      clientToken: 'pub2e1ecc86548781b56a522b049c7b93c2',
      site: 'datadoghq.com',
      service: 'modusign-client-app',
      version,
      env:
        // TODO(@taehwanno): REACT_APP_MODUSIGN_ENV가 stage-default로 변경된다면 아래 조건문 제거 가능
        process.env.REACT_APP_MODUSIGN_ENV === 'stage'
          ? 'stage-default'
          : process.env.REACT_APP_MODUSIGN_ENV, // 'production', 'stage', 'preview'
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
      beforeSend: (log) => {
        const url = log.http?.url;

        // 일부 써드파티 에러 로그는 수집하지 않습니다.
        if (domainDenylist.some((domain) => url?.includes(domain))) {
          return false;
        }

        log.view.url = scrubURL(log.view.url);
        return true;
      },
    });
  }
}

export const logger = datadogLogs.createLogger('modusign-web-app', {
  handler: process.env.NODE_ENV === 'production' ? 'http' : 'console', // 'silent' to disable to logger.
  level: process.env.NODE_ENV === 'production' ? 'info' : 'debug', // minimal log level. 'debug' log won't pass  @see https://docs.datadoghq.com/logs/log_collection/javascript/#filter-by-status
});

export function setLoggerUser(user: { id: string; email?: string; name?: string } | null) {
  if (user) {
    datadogLogs.setUser({
      id: user.id,
      email: user.email,
      name: user.name,
    });
    // 서버에서 userId를 context에 설정해서 서버, 클라이언트 로그를 한번에 검색하기 위해 global context에도 설정합니다.
    datadogLogs.setGlobalContext({
      metadata: {
        userId: user.id,
        userEmail: user.email,
        userName: user.name,
      },
    });
  } else {
    datadogLogs.clearUser();
    datadogLogs.clearGlobalContext();
  }
}
